import { render, staticRenderFns } from "./ComponenteForm.vue?vue&type=template&id=a970ee32&scoped=true&"
import script from "./ComponenteForm.vue?vue&type=script&lang=ts&"
export * from "./ComponenteForm.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteForm.vue?vue&type=style&index=0&id=a970ee32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a970ee32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a970ee32', component.options)
    } else {
      api.reload('a970ee32', component.options)
    }
    module.hot.accept("./ComponenteForm.vue?vue&type=template&id=a970ee32&scoped=true&", function () {
      api.rerender('a970ee32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Devoluciones/ComponenteForm.vue"
export default component.exports